import { useState } from 'react';
import { useCallManager } from '../hooks/useCallManager';
import { useCallStore } from '../stores/call-store';

interface CallControlsProps {
  sessionId: string;
  callUUID?: string;
}

export function CallControls({ sessionId, callUUID }: CallControlsProps) {
  const [isOnHold, setIsOnHold] = useState(false);
  const [showDTMF, setShowDTMF] = useState(false);
  const { hangupCall, sendDTMF, holdCall, unholdCall } = useCallManager();
  const sipSession = useCallStore((state) => state.sipSessions.get(sessionId));

  const handleHangup = async () => {
    await hangupCall(sessionId, callUUID);
  };

  const handleHoldToggle = async () => {
    try {
      if (isOnHold) {
        await unholdCall(sessionId);
      } else {
        await holdCall(sessionId);
      }
      setIsOnHold(!isOnHold);
    } catch (error) {
      console.error('Failed to toggle hold:', error);
    }
  };

  const handleDTMF = async (digit: string) => {
    try {
      await sendDTMF(sessionId, digit);
    } catch (error) {
      console.error('Failed to send DTMF:', error);
    }
  };

  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

  return (
    <div className="call-controls">
      <div className="call-info">
        <div className="remote-identity">
          {sipSession?.remoteIdentity || 'Unknown'}
        </div>
        <div className="call-status">
          {sipSession?.state || 'Unknown'}
          {isOnHold && ' (On Hold)'}
        </div>
      </div>

      <div className="control-buttons">
        <button
          onClick={handleHoldToggle}
          className={`control-button ${isOnHold ? 'active' : ''}`}
          title={isOnHold ? 'Unhold' : 'Hold'}
        >
          {isOnHold ? '▶' : '⏸'}
        </button>

        <button
          onClick={() => setShowDTMF(!showDTMF)}
          className={`control-button ${showDTMF ? 'active' : ''}`}
          title="Keypad"
        >
          #
        </button>

        <button
          onClick={handleHangup}
          className="control-button hangup-button"
          title="Hang up"
        >
          ✕
        </button>
      </div>

      {showDTMF && (
        <div className="dtmf-pad">
          <div className="dtmf-grid">
            {digits.map((digit) => (
              <button
                key={digit}
                onClick={() => handleDTMF(digit)}
                className="dtmf-button"
              >
                {digit}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
